import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, RoutesRecognized } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, pairwise } from 'rxjs/operators';

@Injectable()
export class PreviousRouteService implements OnDestroy {
  private previousUrl: string;
  private currentUrl: string;

  routeSubscription: Subscription;

  constructor(private router: Router) {
    this.currentUrl = this.router.url;
    this.routeSubscription = this.router.events
      .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
      .subscribe({
        next: (events: RoutesRecognized[]) => {
          this.previousUrl = events[0].urlAfterRedirects
          this.currentUrl = events[1].urlAfterRedirects
        }
      });
  }

  public getPreviousUrl(): string {
    return this.previousUrl;
  }

  public getCurrentUrl(): string {
    return this.currentUrl;
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }
}
